import { t } from "i18next"

export const DIVISION_ITEMS = [
  { label: t("New"), value: 1 },
  { label: "修正", value: 2 },
  { label: "取消", value: 3 },
]
